<template>
  <div class="template-list">
    <div class="table-search">
      <el-form :inline="true" :model="form" class="form">
        <el-form-item>
          <el-button type="primary" @click="dialogVisible = true">添加</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-list">
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column prop="templateName" label="模板名" align="center"></el-table-column>
        <el-table-column prop="variableParam" label="变量" align="center"></el-table-column>
        <el-table-column prop="createTime" label="发送时间" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <span class="send" @click="handleConfigDialog(scope.row)">发送配置</span>
            <!-- <span class="del" @click="deleteSmsConfig(scope.row.id)">删除</span> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <addDialog
      :loading="loading"
      :visible="dialogVisible"
      @close="dialogVisible = false"
      @confirm="handleAdd"
    />
    <sendConfig
      :status="status"
      :visible="visible"
      :row="rows"
      @close="visible = false"
      @confirm="handleConfig"
    />
  </div>
</template>
<script>
import {
  getSmsConfigList, addSmsConfig, sendMsg, deleteSmsConfig,
} from '@/api/template';
import sendConfig from './components/sendConfig.vue';
import addDialog from './components/addDialog.vue';

export default {
  data() {
    return {
      status: 0, // 查看显示控制
      rows: {},
      // 列表查询
      form: {
        accessKeyId: '',
        smsSecret: '',
        smsSignName: '',
        templateCode: '',
        variableParam: '',
      },
      tableData: [],
      dialogDate: {}, // 发送配置回显数据存储
      dialogVisible: false, // 添加模板
      visible: false, // 发送配置
      loading: false,
    };
  },
  components: {
    sendConfig,
    addDialog,
  },
  mounted() {
    this.getSmsConfigList();
  },
  methods: {
    getSmsConfigList() {
      this.loading = true;
      getSmsConfigList({
        ...this.form,
      }).then((res) => {
        if (res.success) {
          this.loading = false;
          if (res.data && Array.isArray(res.data)) {
            this.tableData = res.data;
            return this.tableData;
          }
          return false;
        }
        this.$message.error(res.message);
        return false;
      });
    },
    // 添加模板
    addSmsConfig(data) {
      addSmsConfig(data).then((res) => {
        if (res.success) {
          this.loading = false;
          this.dialogVisible = false;
          this.$message.success('添加成功');
          this.getSmsConfigList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 删除模板
    deleteSmsConfig(id) {
      deleteSmsConfig(id).then((res) => {
        if (res.success) {
          this.$message.success('删除成功');
          this.getSmsConfigList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 发送消息
    sendMsg(data) {
      sendMsg(data).then((res) => {
        if (res.success) {
          this.$message.success('发送消息配置成功');
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 输入查询
    handleInputChange() {
      this.getSmsConfigList();
    },
    // 添加模板
    handleAdd(form) {
      this.loading = true;
      this.addSmsConfig(form);
    },
    handleConfigDialog(row) {
      const { variableParam } = row;
      this.rows = {
        ...row,
        variableParam: variableParam.split(','),
      };
      this.visible = true;
    },
    // 发送配置
    handleConfig(form) {
      this.sendMsg(form);
      this.visible = false;
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~assets/css/mixins'
.form
  flex-row()
  justify-content flex-end
.send, .del
  color #1890ff
  cursor pointer
</style>
